import React from "react";
import { useDispatch } from "react-redux";

import { DocumentForm } from "./DocumentForm";
import { addDocument } from "../../actions/companyActions";
import { showToast } from "utils/helpers";
import { useCurrentCompany } from "hooks/auth";

const initialValues = {
	name: "",
	category_id: "",
	sub_category_id: "",
	documentable_type: "App\\Models\\Company",
	file: "",
	extra_info: {
		expiry_date: "",
		accreditation: "",
		relevant_year: "",
		value: "",
		audited: "",
	},
};

export const AddDocument = ({
	onSuccessfulSubmit,
}) => {
	const dispatch = useDispatch();
	const currentCompany = useCurrentCompany();
	const companyId = currentCompany?.id;
	const profileTypeId = currentCompany?.profile_type?.id;


	const handleSubmit = async (values, { setErrors }) => {
		try {
			await dispatch(addDocument(companyId, values));
			onSuccessfulSubmit(); //closeModal
			showToast("Document added successfully.", "Success", true);
		} catch (e) {
			const error = await e.response.json();
			setErrors(error.errors);
			showToast(error.message, "Error");
		}
	};

	return (
		<DocumentForm
			initialValues={initialValues}
			profileTypeId={profileTypeId}
			handleSubmit={handleSubmit}
			title="Add New Document"
		/>
	);
};
